module.exports = __webpack_public_path__ + "img/1m.354d474e.jpg";